import { render } from "./SectionTen.vue?vue&type=template&id=115f79ea&scoped=true"
import script from "./SectionTen.vue?vue&type=script&lang=js"
export * from "./SectionTen.vue?vue&type=script&lang=js"

import "./SectionTen.vue?vue&type=style&index=0&id=115f79ea&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115f79ea"]])

export default __exports__